import { useMemo, useState } from 'react';

import type { ColumnPinningState } from '../types/tanstack-table-types';

/**
 * Тип для фиксирования колонок грида.
 */
export interface GridColumnPinning {
    /**
     * Стейт фиксированных колонок грида.
     */
    columnPinning: ColumnPinningState;
    /**
     * Обработчик изменения стейта фиксированных колонок грида.
     */
    setColumnPinning: (
        columnPinning: ColumnPinningState | ((columnPinning: ColumnPinningState) => ColumnPinningState)
    ) => void;
}

/**
 * Возвращает стейт для хранения состояния фиксированных колонок таблицы и обработчик для изменения стейта.
 *
 * @param initialColumnPinning Начальный стейт фиксированных колонок грида.
 * @returns Стейт фиксированных колонок и обработчик изменения.
 */
export function useGridColumnPinning(initialColumnPinning: ColumnPinningState = {}): GridColumnPinning {
    const [columnPinning, setColumnPinning] = useState<ColumnPinningState>(initialColumnPinning);

    return useMemo(() => ({ columnPinning, setColumnPinning }), [columnPinning, setColumnPinning]);
}
